import { ShopifyAnalyticsConstants } from '@shopify/hydrogen';
import { Faq } from '@snapi/types';
import { FaqPage } from '@snapi/faq';
import { ShopifyAnalyticData } from '../utils/client-analytics';
import { getAnalyticsData } from '../utils/get-analytics-data';
import { useShopifyAnalytics } from '../utils/use-shopify-analytics';

export async function getStaticProps() {
  const { faq } = await (
    await fetch('https://snapihealth.hasura.app/api/rest/faq')
  ).json();

  const analytics = await getAnalyticsData();

  return {
    props: {
      faq,
      analytics,
    },
  };
}

interface FaqProps {
  faq: Faq[];
  analytics: ShopifyAnalyticData;
}

export default function Index({ faq, analytics }: FaqProps) {
  useShopifyAnalytics(ShopifyAnalyticsConstants.pageType.article, analytics);

  return <FaqPage faq={faq} />;
}
